import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { stringify } from 'postcss';

export default class media {

    constructor(container, template) {
        this.code;
        this.currentPage = 0;
        this.template = template;
        this.container = container;
        this.parent = document.querySelector('.media');
        this.ajaxPath = this.container.getAttribute('data-ajax-path');
        this.preloader = '<div class="preloader"></div>';
        this.showMoreBtn = localize({
            'en': 'Show more',
            'ru': 'Загрузить еще',
            'kz': 'Тағы да қарау'
        })
    }

    set setCurrentPage(value) {
        this.currentPage = value;
    }

    get setCurrentPage() {
        return this.currentPage;
    }

    getData(firstLoad = false) {
        this.setCurrentPage = this.currentPage + 1;

        let url = this.ajaxPath + this.createQueryString();

        this.loading(true);
        this.container.innerHTML += this.preloader;

        fetch(url).then(response => {
            response.json().then(data => {
                this.loading(false);
                this.container.querySelector('.preloader').remove();
                this.dataProcessing(data, firstLoad);
            });
        }, error => {
            console.log(error);
        });
    }

    dataProcessing(data, firstLoad) {
        if (firstLoad) {
            const thisHash = window.location.hash;

            this.setCurrentPage = parseInt(data.current);
            this.container.innerHTML = this.template(data);

            /* Open modal for firstLoad if hash length */
            if (thisHash) {
                $(thisHash).trigger('click');
            }

            if (data.total > 1) this.moreBtn();
        } else {
            this.setCurrentPage = parseInt(data.current);
            this.container.insertAdjacentHTML('beforeend', this.template(data));
            if (this.currentPage >= data.total) this.moreBtn(false);
        };
    }

    createQueryString() {
        let string = '?current=' + this.currentPage,
            itemCode = '&code=' + this.code;

        if (this.code != '' && typeof(this.code) != 'undefined') string += itemCode;

        return string;
    }

    moreBtn(status = true) {
        if (status) {
            let moreBtn = document.createElement('a');

            moreBtn.innerHTML = this.showMoreBtn;
            moreBtn.setAttribute('href', 'javascript: void(0);');
            moreBtn.className = 'media__more btn btn--orange';
            moreBtn.addEventListener('click', () => {
                this.getData();
            });
            this.parent.appendChild(moreBtn);
        } else {
            this.parent.querySelector('.media__more').remove();
        };
    }

    loading(status) {
        status ? this.parent.classList.add('loading') : this.parent.classList.remove('loading');
    }

    appendBackBtn() {
        const backBtn = document.createElement('a');
        const currentUrl = window.location;

        backBtn.setAttribute('href', currentUrl.pathname.replace(`${this.code}/`, ''));
        backBtn.classList.add('media__back-btn')
        backBtn.innerHTML = localize({
            'en': 'Back to albums',
            'ru': 'Назад к альбомам',
            'kz': 'Back to albums'
        });
        this.parent.prepend(backBtn);
    }
}


// WEBPACK FOOTER //
// ./frontend/components/media/media.js